import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function WorkerPerformanceManage (props){

    return <BasicCrudScreenType id ="PerfomanceManage" table ="WorkerPerformance" view ="VwWorkerPerformance"/>
}

export default WorkerPerformanceManage;